module.exports = __webpack_public_path__ + "static/media/total.4b10fab5.svg";